// src/domains/core/dashboard/components/widgets/smarthome/SmartHomeStatusWidget.tsx

import { Home } from "lucide-react";
import { type FC } from "react";
import { useNavigate } from "react-router-dom";

import { Button, Text, Heading, Card } from "@/components/ui";

import { useWidgetConfig } from "../../../hooks/useWidgetConfig";
import { WIDGET_IDS } from "../../../store/widgetRegistry";
import { WidgetContainer } from "../base";

/**
 * SmartHomeStatusWidget - Quick Access zu Smart Home
 *
 * NOTE: Smart Home Device Status wird in zukünftiger Version implementiert
 *
 * @returns {JSX.Element} Smart home status widget component
 *
 */
export const SmartHomeStatusWidget: FC = () => {
  const { config } = useWidgetConfig(WIDGET_IDS.SMARTHOME_STATUS);
  const navigate = useNavigate();

  // NOTE: Smart Home Device Status Hook wird in zukünftiger Version implementiert
  const loading = false;
  const activeDevices = 0;
  const totalDevices = 0;

  return (
    <WidgetContainer
      description="Device status"
      icon={<Home className="w-5 h-5" />}
      loading={loading}
      size={config?.size ?? "small"}
      title="Smart Home"
      widgetId={WIDGET_IDS.SMARTHOME_STATUS}
    >
      <div className="space-y-3">
        <Card className="text-center" padding="sm" variant="default">
          <Text className="text-xs text-gray-400 mb-1">Active Devices</Text>
          <Heading className="text-xl font-bold text-white" level={4}>
            {activeDevices} / {totalDevices}
          </Heading>
        </Card>

        <Button
          className="w-full"
          onClick={() => {
            // Reason: navigate() returns void, but ESLint treats it as Promise
            // eslint-disable-next-line sonarjs/void-use -- Reason: navigate() returns void, not Promise
            void navigate("/smarthome");
          }}
          size="sm"
          variant="outline"
        >
          Manage Devices
        </Button>
      </div>
    </WidgetContainer>
  );
};
